const user = state => state.user;
const id = state => state.user.id;
const email = state => state.user.email;
const status = state => state.user.status;
const is2Fa = state => state.user.is2Fa;
const isPreferKyc = state => state.user.isPreferKyc;

export default {
  user,
  id,
  email,
  status,
  is2Fa,
  isPreferKyc,
};
